import { HttpErrorResponse } from '@angular/common/http';
import { AttributeType, MetaData } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getAttributeTypes = createAction('[AttributeTypeFilters] Get Attribute Types');

export const getAttributeTypesSuccess = createAction(
    '[AttributeTypeFilters] Get Attribute Types Success',
    props<{ attributeTypes: AttributeType[]; metadata: MetaData | null; searchText: string | null }>()
);

export const getAttributeTypesFailure = createAction(
    '[AttributeTypeFilters] Get Attribute Types Failure',
    props<{ error: HttpErrorResponse }>()
);

export const fetchAttributeTypes = createAction('[AttributeTypeFilters] Fetch Attribute Types');

export const searchAttributeTypes = createAction(
    '[AttributeTypeFilters] Get Attribute Types With Search',
    props<{ searchText: string; delay: number }>()
);

export const isLoadingAttributeTypes = createAction('[AttributeTypeFilters] Loading Attribute Types');

export const amendAttributeTypeSelections = createAction('[AttributeTypeFilters] Amend Selected Attribute Types');

export const getNextPageAttributeTypes = createAction('[AttributeTypeFilters] Get Next Page Attribute Types');

export const updateAttributeTypesSelectionSuccess = createAction(
    '[AttributeTypeFilters] Get Next Page Attribute Types Success',
    props<{ attributeTypes: AttributeType[]; metadata: MetaData | null }>()
);
